/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Delete_ConfirmInputs */

const en_document_delete_confirm = /** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this document permanently?`)
};

const id_document_delete_confirm = /** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus dokumen ini secara permanen?`)
};

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const es_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const fr_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const de_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const ja_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const zh_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const ar_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const it_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const ru_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const pt_document_delete_confirm = en_document_delete_confirm;

/** @type {(inputs: Document_Delete_ConfirmInputs) => LocalizedString} */
const ko_document_delete_confirm = en_document_delete_confirm;

/**
* | output |
* | --- |
* | "Delete this document permanently?" |
*
* @param {Document_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_delete_confirm = /** @type {((inputs?: Document_Delete_ConfirmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Delete_ConfirmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_delete_confirm(inputs)
	if (locale === "es") return es_document_delete_confirm(inputs)
	if (locale === "fr") return fr_document_delete_confirm(inputs)
	if (locale === "de") return de_document_delete_confirm(inputs)
	if (locale === "ja") return ja_document_delete_confirm(inputs)
	if (locale === "zh") return zh_document_delete_confirm(inputs)
	if (locale === "ar") return ar_document_delete_confirm(inputs)
	if (locale === "id") return id_document_delete_confirm(inputs)
	if (locale === "it") return it_document_delete_confirm(inputs)
	if (locale === "ru") return ru_document_delete_confirm(inputs)
	if (locale === "pt") return pt_document_delete_confirm(inputs)
	return ko_document_delete_confirm(inputs)
});